import React from 'react';
import { CardElement, injectStripe } from 'react-stripe-elements';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

const styles = theme => ({
  container: {
    maxWidth: 450,
  },
  textField: {
    width: '100%',
    '& label': {
      fontSize: 14,
    },
    '& input': {
      fontSize: 14,
    },
  },
  title: {},
  cardField: {
    '&.StripeElement': {
      margin: '10px 0 20px 0',
      backgroundColor: 'white',
      padding: '5px 5px',
      borderBottom: '1px solid #CCC',
      lineHeight: 1.3,
      marginTop: 24,
      marginBottom: 15,
      maxWidth: 440,
    },
    '&.StripeElement--focus': {
      borderColor: '#66AFE9',
    },
  },
  button: {
    marginTop: theme.spacing.unit * 4,
  },
});

const BillingForm = props => {
  const {
    classes,
    name,
    line1,
    line2,
    city,
    state,
    handleChange,
    handleCardChange,
    handleSubmit,
    isPayButtonDisabled,
  } = props;

  const _handleSubmit = event => {
    event.preventDefault();
    return handleSubmit(event, props.stripe);
  };

  return (
    <form onSubmit={_handleSubmit} className={classes.container}>
      <Typography variant="title" className={classes.title}>
        Card Details
      </Typography>
      <TextField
        required
        id="name"
        label="Name on card"
        value={name}
        className={classes.textField}
        margin="normal"
        onChange={handleChange}
      />
      <CardElement
        className={classes.cardField}
        onChange={handleCardChange}
        style={{
          base: {
            fontSize: '14px',
            fontFamily: `Arial, Helvetica, sans-serif`,
          },
        }}
      />
      <br />
      <br />
      <Typography variant="title" className={classes.title}>
        Billing Address
      </Typography>
      <TextField
        required
        id="line1"
        label="Line 1"
        value={line1}
        className={classes.textField}
        margin="normal"
        onChange={handleChange}
      />
      <TextField
        id="line2"
        label="Line 2"
        value={line2}
        className={classes.textField}
        margin="normal"
        onChange={handleChange}
      />
      <TextField
        required
        id="city"
        label="City"
        value={city}
        className={classes.textField}
        margin="normal"
        onChange={handleChange}
      />
      <TextField
        required
        id="state"
        label="State"
        value={state}
        className={classes.textField}
        margin="normal"
        onChange={handleChange}
      />
      <Button
        type="submit"
        variant="raised"
        color="primary"
        disabled={isPayButtonDisabled}
        className={classes.button}
      >
        Pay
      </Button>
    </form>
  );
};

export default injectStripe(withStyles(styles)(BillingForm));



// WEBPACK FOOTER //
// ./src/components/BillingForm.js